// extracted by mini-css-extract-plugin
export default {"cls1":"SeasonalDiscountUnibrow-cls1___c95060d44af842a4b41","cls2":"SeasonalDiscountUnibrow-cls2___ce18f971b7de831789c SeasonalDiscountUnibrow-cls1___c95060d44af842a4b41"};